<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.srb_id"
                    placeholder="返还单号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家名称"
                    clearable
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.type"
                    placeholder="返还类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in search_ops.types"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    multiple
                    placeholder="状态"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in search_ops.status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="生成时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="分账日期：">
                  <el-date-picker
                    v-model="form.pay_time"
                    type="datetimerange"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 70px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div style="margin-left: 10px; color: #f40000; font-size: 14px">
            <div>"待转账"状态的返还单，将于每日15:00点自动发起分账</div>
            <div>单据生成时金额大于0元的会被自动挂起，需要业务审核并激活</div>
          </div>
          <div style="margin-left: auto">
            <el-button size="mini" type="primary" @click="handleSendMsg">
              发送短信
            </el-button>
            <el-button
              size="mini"
              type="primary"
              @click="handleActivate(IS_STATISTIC)"
            >
              批量激活为待转账
            </el-button>
            <el-button
              slot="trigger"
              size="mini"
              type="success"
              @click="exportExcel"
              >导出</el-button
            >
            <div
              v-if="resData.send_msg_time"
              style="color: #f40000; font-size: 12px"
            >
              最近发送短信时间：{{ resData.send_msg_time }}
            </div>
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              align="center"
              prop="srb_id"
              label="返还单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="title"
              label="返还单名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_id"
              label="商家id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_refund_bill_type"
              label="返还类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="total"
              label="结算金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refund_service_rate"
              label="退货比例"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="commission"
              label="上月已扣佣金总计"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="prenew_goodsno_rate"
              label="提前上新比例"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="prenew_goodsno_rate"
              label="配货率情况"
            >
              <template slot-scope="scope">
                <div>
                  <span style="margin-left: 10px">24配：</span
                  >{{ scope.row.allot_24h_rate }}
                </div>
                <div><span>最终配：</span>{{ scope.row.allot_240h_rate }}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="level"
              label="达标档位"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refund_amt_rate"
              label="返佣比例"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refund_amt"
              label="返还金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_refund_bill_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="remark"
              label="分账失败原因"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="生成时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_time"
              label="分账时间"
            ></el-table-column>
            <el-table-column
              align="center"
              label="操作"
              fixed="right"
              width="150px"
            >
              <template slot-scope="scope">
                <div style="margin-bottom: 10px">
                  <el-button size="mini" @click="handleLogOpen(scope.row)">
                    日志
                  </el-button>
                </div>
                <div
                  v-if="['3', '4'].includes(scope.row.status)"
                  style="margin-bottom: 10px"
                >
                  <el-button
                    type="success"
                    size="mini"
                    @click="activation(scope.row)"
                    >激活为待转账</el-button
                  >
                </div>
                <div
                  v-if="['0'].includes(scope.row.status)"
                  style="margin-bottom: 10px"
                >
                  <el-button
                    type="danger"
                    size="mini"
                    @click="hangUp(scope.row)"
                    >挂起</el-button
                  >
                </div>
                <div v-if="['4', '5'].includes(scope.row.status)">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="deleteRow(scope.row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[10, 50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="操作日志" :visible.sync="logVisible">
      <el-table :data="logData">
        <el-table-column
          property="admin"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column
          property="operate_mode"
          label="操作方式"
          align="center"
        ></el-table-column>

        <el-table-column
          property="operate_result"
          label="操作结果"
          align="center"
        ></el-table-column>
        <el-table-column
          property="created_at"
          label="操作时间"
          align="center"
        ></el-table-column>
        <el-table-column
          property="remark"
          label="备注"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { batchActivation, logList } from "@/controller/refundBill.js";
import {
  getNeedSendMsgSupply,
  sendMsgSupply,
} from "@/controller/refundBill3143.js";
import apiBaseURL from "@/utils/baseUrl.js";

const IS_STATISTIC = 1;
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.srb_id) {
        vm.form.srb_id = to.query.srb_id;
        vm.form.create_time = [];
      }
      vm.fetchData();
    });
  },
  data() {
    return {
      IS_STATISTIC,
      logVisible: false,
      logData: [],
      resData: {},
      form: {
        create_time: this.defaultDate(),
        pagesize: 100,
        srb_id: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/RefundBill/index",
      action: "",
      curPage: 1,
      filterFold: false,
      multipleSelection: [],
      search_ops: {
        types: [
          {
            key: 1,
            label: "佣金奖励",
          },
          {
            key: 2,
            label: "退货服务费奖励",
          },
          {
            key: 3,
            label: "提前上新返佣奖励",
          },
          {
            key: 4,
            label: "履约达标返佣奖励",
          },
          {
            key: 5,
            label: "履约达标返佣奖励(新)",
          },
        ],
        status: [
          {
            key: 0,
            label: "待分账",
          },
          {
            key: 1,
            label: "分账中",
          },
          {
            key: 2,
            label: "分账成功",
          },
          {
            key: 3,
            label: "分账失败",
          },
          {
            key: 4,
            label: "挂起",
          },
          {
            key: 5,
            label: "异常",
          },
        ],
      },
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },
  methods: {
    activation(row) {
      this.$confirm('激活为"待转账"状态?')
        .then(() => {
          this.$http
            .post("/erp/RefundBill/activation", {
              srb_id: row.srb_id,
            })
            .then((rs) => {
              if (rs.data.code !== 200) return this.$message.error(rs.data.msg);
              this.$message.success(rs.data.msg);
              this.fetchData(true);
            });
        })
        .catch();
    },
    hangUp(row) {
      this.$confirm("挂起返还单?")
        .then(() => {
          this.$http
            .post("/erp/RefundBill/hangUp", { srb_id: row.srb_id })
            .then((rs) => {
              if (rs.data.code !== 200) return this.$message.error(rs.data.msg);
              this.$message.success(rs.data.msg);
              this.fetchData(true);
            });
        })
        .catch();
    },
    deleteRow(row) {
      this.$confirm("确定删除,删除后不可恢复?")
        .then(() => {
          this.$http
            .post("/erp/RefundBill/delete", { srb_id: row.srb_id })
            .then((rs) => {
              if (rs.data.code !== 200) return this.$message.error(rs.data.msg);
              this.$message.success(rs.data.msg);
              this.fetchData(true);
            });
        })
        .catch();
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    addColor() {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      Object.keys(val).forEach((key) => {
        multipleSelection[key] = val[key].srb_id;
      });
      this.multipleSelection = multipleSelection;
    },

    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
    },
    // 批量激活
    handleActivate(statistic) {
      const params = {
        statistic,
        srb_ids: this.multipleSelection,
      };
      batchActivation(params)
        .then((data) => {
          const { num, totalAmount } = data;
          if (num > 0) {
            this.$confirm(`激活：共${num}单，计${totalAmount}元`, "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleActivate("");
              })
              .catch(() => {
                console.log("关闭");
              });
          } else {
            this.$message.success("操作成功");
            this.fetchData(true);
          }
        })
        .catch(this.$noop);
    },
    async handleSendMsg() {
      try {
        const data = await getNeedSendMsgSupply();
        const { month, meet, dont_meet: dontMeet } = data;
        const title = `确认发送 ${month} 月返佣短信？`;
        const content = `将向 ${meet} 位商家发送履约达标短信，${dontMeet} 位商家发送履约未达标短信`;
        this.$confirm(content, title, {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              const data = await sendMsgSupply();
              this.$message({
                type: "success",
                message: data,
              });
            } catch (err) {
              this.$message({
                type: "error",
                message: err.msg,
              });
            }
          })
          .catch(this.$noop);
      } catch (err) {
        this.$message({
          type: "error",
          message: err.msg,
        });
      }
    },
    handleLogOpen(row) {
      logList({ srb_id: row.srb_id })
        .then((data) => {
          this.logData = data;
          this.logVisible = true;
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/refundBill/RefundBillList.vue